import React from 'react';
import PropTypes from 'prop-types';
// import $ from 'jquery';
// import 'bootstrap-select';

// https://stackoverflow.com/questions/52464915/react-error-webpack-imported-module-4-jquery-default-modal-is-no/52464960

export default class DocumentStateSelect extends React.Component {

    componentDidUpdate() {
        if ( this.props.field.options.length > 0 )
            window.$(this.refs.select).selectpicker();
    }

    componentDidMount() {
        if ( this.props.field.options.length > 0 )
            window.$(this.refs.select).selectpicker();
    }

    render() {
        const { field, onChange} = this.props;
        const { meta: { touched, error } } = field;

        return (
            <div className={field.colWidth}>
                <div className="form-group">
                    <label htmlFor={field.name}>{field.label}</label>
                    <select
                        ref="select"
                        className="form-control show-tick"
                        id={field.name}
                        {...field.input}
                        disabled={field.disabled || false}>
                        {
                            field.options.map((opt, i) => {
                                const content = `<span class="valido" style="background-color:#${opt.color};"></span>${opt.name}`;
                                return (
                                    <option
                                        key={i}
                                        data-content={content}
                                        value={opt.value}
                                        children={opt.name}
                                    />
                                );
                            })
                        }
                    </select>
                    <div className="text-error">
                        {touched ? error : ''}
                    </div>
                </div>
            </div>
        );
    }
}

DocumentStateSelect.propTypes = {
    field: PropTypes.objectOf(PropTypes.any).isRequired,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentStateSelect.js